import { useSubscription } from 'urql';
import { ChatMessageItemFragment } from '@/components/Chat/ChatMessageItem.utils';
import { graphql } from '@/gql/graphql';
import { useChatStore } from '@/stores/useChatStore';
import useSubscriptionStream from './useSubscriptionStream';

export const WatchPersonFragment = graphql(/* GraphQL */ `
  fragment WatchPerson on person {
    __typename
    id
    first_name
    last_name
    name
    avatar_id
    color
    username
    is_complete
    notification_counts {
      id
      unseen_notification_count
    }
    event_push_interval
    chat_notification_preference
    updated_at
    event_participation_updated_at
    team_participation_updated_at
    chat_participation_updated_at
    unseen_message_count
  }
`);

export const WatchPerson = graphql(/* GraphQL */ `
  subscription WatchPerson($excludeChatId: uuid) {
    current_user {
      id
      tab_unseen_message_count: unseen_message_count(
        args: { exclude_chat_id: $excludeChatId }
      )
      ...WatchPerson
    }
  }
`, [WatchPersonFragment]);

export const WatchMessageMediaStream = graphql(/* GraphQL */ `
  subscription WatchMessageMediaStream($cursor: timestamptz!) {
    message_media_stream(
      batch_size: 25
      cursor: { initial_value: { updated_at: $cursor } }
    ) {
      id
      message_id
      created_by
      updated_at
      media_id
      order
      url
      mime_type
      og_title
      og_description
      og_image_height
      og_image_width
      og_image_url
    }
  }
`);

export const WatchChatPreferenceStream = graphql(
  /* GraphQL */ `
    subscription WatchChatPreferenceStream($cursor: timestamptz!) {
      chat_person_preference_stream(
        batch_size: 25
        cursor: { initial_value: { updated_at: $cursor } }
      ) {
        chat_id
        updated_at
        person_id
        last_seen_at
        notification_preference
        chat {
          id
          unseen_message_count
          preference {
            chat_id
            person_id
            notification_preference
          }
          is_hidden
        }
      }
    }
  `,
);

export const WatchNewMessagesStream = graphql(/* GraphQL */ `
  subscription WatchNewMessagesStream($cursor: timestamptz!) {
    message_stream(
      batch_size: 100
      cursor: { initial_value: { updated_at: $cursor } }
    ) {
      updated_at
      created_at
      chat {
        chat_type
        id
        is_hidden
        preference {
          chat_id
          person_id
          notification_preference
        }
        last_message_at
        metadata
        unseen_message_count
      }
      ...ChatMessageItem
    }
  }
`, [ChatMessageItemFragment]);

export default function useGlobalSubscriptions() {
  const viewedChatId = useChatStore((state) => state.viewedChatId);
  useSubscriptionStream('message', {
    query: WatchNewMessagesStream,
  });

  useSubscriptionStream('chat_person_preference', {
    query: WatchChatPreferenceStream,
  });

  useSubscriptionStream('message_media', {
    query: WatchMessageMediaStream,
  });

  useSubscription({
    query: WatchPerson,
    variables: { excludeChatId: viewedChatId },
  });
}
